module.exports = __webpack_public_path__ + "img/relativeRelations.617cf336.svg";